$(function () {
    var footer_nav_trigger = $('.footerNavTrigger');
    var footer_nav = $('.footerNav');
    var break_point = 992;
    var browser_width = window.innerWidth;

    if (browser_width < break_point) {
        footer_nav_trigger.attr('role', 'button').removeAttr('aria-level');

        footer_nav_trigger.click(function (e) {
            e.preventDefault();
            /* close an open accordion */
            if ($(this).hasClass('__active')) {
                $(this).removeClass('__active').attr('aria-expanded', false);
                $(this).next('ul').slideUp();
            }
            else {
                $(this).addClass('__active').attr('aria-expanded', true);
                $(this).next('ul').slideDown();
            }
        });
    }

    else {
        footer_nav_trigger.attr('role', 'heading').attr('aria-level', '2');
    }
});
